import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedProduct } from '../../core/product/product';
import { ActivatedAddon } from '../../core/activated-addon';

export interface DeactivateDependentProductDialogDataInterface {
  requiredProduct: ActivatedProduct;
  dependentProducts: (ActivatedProduct | ActivatedAddon)[];
  dependentProductsToNumberOfActivations?: Map<string, number>;
  scheduleDeactivationDate?: Date;
}

@Component({
  styleUrls: ['deactivate-dependent-product-dialog.component.scss'],
  templateUrl: 'deactivate-dependent-product-dialog.component.html',
  standalone: false,
})
export class DeactivateDependentProductDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeactivateDependentProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeactivateDependentProductDialogDataInterface,
  ) {}

  continueDeactivate(): void {
    this.dialogRef.close(true);
  }
}
